import dayjs from 'dayjs';

export const DATE_FORMAT = 'MMM D, YYYY';
export const DATE_TIME_FORMAT = 'MMM D, YYYY - hh:mm A';
export const DATE_TIME_WITH_SECONDS_FORMAT = 'MMM D, YYYY - hh:mm:ss A';

const isDateInput = (value: unknown): value is string | number | Date => {
  return typeof value === 'string' || typeof value === 'number' || value instanceof Date;
};

const formatDateValue = (value: unknown, format: string, fallback: string): string => {
  if (value == null || value === '' || !isDateInput(value)) {
    return fallback;
  }

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(format) : fallback;
};

export const formatDate = (value: unknown, fallback = ''): string =>
  formatDateValue(value, DATE_FORMAT, fallback);

export const formatDateTime = (value: unknown, fallback = ''): string =>
  formatDateValue(value, DATE_TIME_FORMAT, fallback);

export const formatDateTimeWithSeconds = (value: unknown, fallback = ''): string =>
  formatDateValue(value, DATE_TIME_WITH_SECONDS_FORMAT, fallback);
